import React from "react";
import DiscountTypeSelector from "./components/DiscountTypeSelector";
import DiscountValueInput from "./components/DiscountValueInput";
import DateRangeInputs from "./components/DateRangeInputs";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../../translations";


const DiscountForm = ({
    discountData,
    setDiscountData,
    onSubmit,
    onCancel,
    selectedProduct,
    calculateDiscountedPrice,
    isBulk
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    const updateDiscountData = (field, value) => {
        setDiscountData({ ...discountData, [field]: value });
    };

    return (
        <form onSubmit={onSubmit} className="discount-form">
            <DiscountTypeSelector
                discountType={discountData.type}
                onChange={(type) => updateDiscountData('type', type)}
            />

            <DiscountValueInput
                discountType={discountData.type}
                value={discountData.value}
                onChange={(value) => updateDiscountData('value', value)}
            />

            <DateRangeInputs
                startDate={discountData.startDate}
                endDate={discountData.endDate}
                onStartDateChange={(date) => updateDiscountData('startDate', date)}
                onEndDateChange={(date) => updateDiscountData('endDate', date)}
            />

            <div className="form-group">
                <label>Description (Optional)</label>
                <input
                    type="text"
                    value={discountData.description}
                    onChange={(e) => updateDiscountData('description', e.target.value)}
                    placeholder="e.g., Summer Sale, Black Friday Deal"
                />
            </div>

            {/* {!isBulk && selectedProduct && (
                <DiscountPreview
                    product={selectedProduct}
                    discountData={discountData}
                    calculateDiscountedPrice={calculateDiscountedPrice}
                />
            )} */}

            <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={onCancel}>
                    {t('cancel')}
                </button>
                <button
                    type="submit"
                    className="save-btn"
                    disabled={!discountData.value}
                >
                    {t('applyDiscount')}
                </button>
            </div>
        </form>
    );
};

export default DiscountForm;